import { useEffect, useMemo } from "react";
import MHNav from "./components/MHNav";
import MHHero from "./components/MHHero";
import MHAbout from "./components/MHAbout";
import MHPartners from "./components/MHPartners";
import MHEvents from "./components/MHEvents";
import MHContact from "./components/MHContact";
import MHFooter from "./components/MHFooter";
import SEOJsonLd from "../../components/base/SEOJsonLd";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://meethiszpania.com";

export default function MeetHiszpaniaPage() {
  useEffect(() => {
    document.title = "Meet Hiszpania - Platforma B2B | Łączymy Polskę z Hiszpanią";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "Meet Hiszpania to platforma B2B łącząca polskie agencje turystyczne z najlepszymi obiektami w Hiszpanii. Eventy, partnerstwa i wsparcie dla profesjonalistów turystyki.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE_URL}/`);
  }, []);

  const jsonLd = useMemo(() => ([
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Meet Hiszpania",
      "url": `${SITE_URL}/`,
      "logo": `${SITE_URL}/logo.png`,
      "description": "Meet Hiszpania to platforma B2B łącząca polskie agencje turystyczne z najlepszymi obiektami w Hiszpanii.",
      "sameAs": [],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "availableLanguage": ["Polish", "Spanish", "English"]
      },
      "areaServed": ["PL", "ES"]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Meet Hiszpania",
      "url": `${SITE_URL}/`,
      "inLanguage": "pl",
      "description": "Platforma B2B łącząca Polskę z Hiszpanią – eventy, partnerstwa i wsparcie dla profesjonalistów turystyki.",
      "publisher": {
        "@type": "Organization",
        "name": "Meet Hiszpania"
      }
    }
  ]), []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <SEOJsonLd data={jsonLd} id="jsonld-meet-hiszpania" />
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap" rel="stylesheet" />
      <MHNav />
      <MHHero />
      <MHAbout />
      <MHPartners />
      <MHEvents />
      <MHContact />
      <MHFooter />
    </div>
  );
}